import instance from "../config/axios";
import { url, base_apis } from "../config/url";

export const getFeaturedVideo = (data) => {
    return instance.post(`${base_apis.liveStream}/list`, data)
        .then((res) => {
            return res;
        });
};

export const getTopProfiles = (data) => {
    return instance.post(`${base_apis.user}/top-profiles`, data)
        .then((res) => {
            return res;
        });
};

export const getFollowers = (data) => {
    return instance.post(`${base_apis.topProfileFollower}/follow-user`, data)
        .then((res) => {
            return res;
        });
};

export const getBlogs = (data) => {
    return instance.post(`${base_apis.blogs}/list`, data)
        .then((res) => {
            return res;
        });
};

export const getBlogDetails = (id) => {
    return instance.get(`${base_apis.blogs}/get/${id}`) // Use GET instead of POST for fetching details
        .then((res) => res);
};